"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));

var DropdownButton_1 = __importDefault(require("react-bootstrap/DropdownButton"));

var Icon_1 = __importDefault(require("../Icon"));

require("./index.css");

var DropdownItem = function (_a) {
  var item = _a.item;
  var className = item.disabled ? 'outline icon-grey-medium' : 'outline icon-orange-theme';
  var iconContainer = item.icon ? (0, jsx_runtime_1.jsx)(Icon_1.default, {
    name: item.icon,
    className: className
  }, void 0) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
  return (0, jsx_runtime_1.jsxs)(Dropdown_1.default.Item, __assign({
    disabled: item.disabled,
    onClick: item.onClick
  }, {
    children: [iconContainer, item.text]
  }), void 0);
};

var DropdownMenu = function (_a) {
  var title = _a.title,
      items = _a.items;
  return (0, jsx_runtime_1.jsx)(DropdownButton_1.default, __assign({
    title: title,
    variant: "",
    menuAlign: "right"
  }, {
    children: items.map(function (item) {
      return (0, jsx_runtime_1.jsx)(DropdownItem, {
        item: item
      }, item.text);
    })
  }), void 0);
};

var itemShape = {
  text: prop_types_1.string.isRequired,
  icon: prop_types_1.string,
  disabled: prop_types_1.bool,
  onClick: prop_types_1.func
};
DropdownItem.propTypes = {
  item: (0, prop_types_1.shape)(itemShape)
};
DropdownItem.defaultProps = {
  item: {}
};
DropdownMenu.propTypes = {
  title: prop_types_1.string,
  items: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)(itemShape))
};
DropdownMenu.defaultProps = {
  title: '',
  items: []
};
exports.default = DropdownMenu;